import Customer from "@/model/Customer.model";
import { assignOrderItem, createOrderItem } from "@/model/OrderItem.model";
import { OrderStatus } from "@/model/enum/OrderStatus";
import { OrderPaymentStatus } from "@/model/enum/OrderPaymentStatus";
import Totals from "@/model/Totals";
import { Ledger } from "@/model/Ledger";
export default class Order {
    id;
    customer = new Customer();
    orderItems = [];
    paymentMethod;
    orderDatetime;
    orderStatus = OrderStatus.NEW;
    paymentStatus = OrderPaymentStatus.PENDING;
    paymentReference;
    customerRemarks;
    internalRemarks;
    ledger;
    editState;
    invoiced = false;
    bookingNumber;
    totals = new Totals();
    assign(other) {
        Object.assign(this, other);
        this.customer = new Customer();
        this.customer.init(other.customer);
        if (other.ledger != undefined) {
            this.ledger = new Ledger();
            this.ledger.assign(other.ledger);
        }
        this.orderItems = [];
        if (other.orderItems) {
            other.orderItems.forEach(orderItem => {
                const typedOrderItem = createOrderItem();
                assignOrderItem(typedOrderItem, orderItem);
                this.orderItems.push(typedOrderItem);
            });
        }
        const typedTotals = new Totals();
        typedTotals.assign(other.totals);
        this.totals = typedTotals;
        if (other.orderDatetime) {
            this.orderDatetime = new Date(other.orderDatetime);
        }
    }
}
